import { AxiosResponse } from "axios";
import { getBrokers } from "../../api";
import { Broker } from "../../dtos/track-activity";
import { useDropdownOptions } from "../use-drop-down-options.hook";

const fetchBrokers = (search?: string) => getBrokers({ search });

const toBrokerOptions = (res: AxiosResponse<Broker[]>) =>
  (res?.data ?? []).map((broker) => ({
    label: broker.name,
    value: broker.uid,
  }));

const useBrokerOptions = () => {
  const { options, isLoading, handleSearchChange } = useDropdownOptions<
    AxiosResponse<Broker[]>
  >({
    queryKey: "brokers",
    searchable: true,
    fetchFn: fetchBrokers,
    transformData: toBrokerOptions,
  });

  return { options, isLoading, handleSearchChange };
};

export default useBrokerOptions;
